
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/privacy-and-cookie",
      function () {
        return require("private-next-pages/privacy-and-cookie.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/privacy-and-cookie"])
      });
    }
  